<template>
  <v-container class="d-flex flex-column align-center" style="height: 100vh;">
    <img
      src="MediaAnalytic.png"
      width="600"
      alt="MediaAnalytics"
      class="module-image"
    />

    <v-row>
      <v-col cols="12" class="text-center">
        <h1 class="combined-text">
          <span class="media-text">Media</span> <span class="analytics-text">Analytics</span>
        </h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MediaAnalyticComponent',

  mounted() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  },
};
</script>

<style scoped>
.module-image {
  margin-top: -60px;
}

.combined-text {
  font-size: 48px;
  font-weight: bold;
}

.media-text {
  color: #007bff;
}

.analytics-text {
  color: #000000;
}
</style>
